import { render, staticRenderFns } from "./AppointmentsOverviewTable.vue?vue&type=template&id=2101535d&"
import script from "./AppointmentsOverviewTable.vue?vue&type=script&lang=js&"
export * from "./AppointmentsOverviewTable.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentsOverviewTable.vue?vue&type=style&index=0&id=2101535d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports